import AbstractNormalizersResolver from "../../core/AbstractNormalizersResolver";
import ViewItemNormalizer from "./ViewItemNormalizer";
export default class ViewItemNormalizersResolver extends AbstractNormalizersResolver {
    register() {
        return [
            new ViewItemNormalizer(),
        ];
    }
}
